if (!window.landingSpecialInitialized) {
  window.landingSpecialInitialized = true;

  const initLanding = () => {
    // Apply class to main content, fallback to body if main not found
    const mainContent =
      document.getElementById("MainContent") ||
      document.querySelector("main") ||
      document.body;
    mainContent.classList.add("special-landing");
    console.log("DOMContentLoaded landing - special-landing applied");

    class VideoManager {
      constructor() {
        this.video1 = document.getElementById("video1");
        this.video2 = document.getElementById("video2");
        this.loadingVideo = document.querySelector(".loading-video");
        this.mainVideo = document.querySelector(".main-video");
        this.actContainer = document.querySelector(".special-landing");
        this.scrollHint = document.querySelector("[data-loader-scroll-hint]");

        // Generic session storage key based on page handle
        const handle = window.location.pathname.split("/").pop() || "landing";
        this.storageKey = `hasVisited_${handle}`;
        this.hasVisited = sessionStorage.getItem(this.storageKey);

        this.init();
      }

      init() {
        if (!this.video1) {
          this.handleNoIntroVideo();
        } else if (this.hasVisited) {
          this.skipToMainVideo();
        } else {
          try {
            if (this.loadingVideo) this.loadingVideo.classList.remove("hidden");
            this.setupVideoTransition();
            sessionStorage.setItem(this.storageKey, "true");
          } catch (e) {
            console.error("Video setup error", e);
            this.handleNoIntroVideo(); // Fallback
          }
        }
      }

      handleNoIntroVideo() {
        this.hideLoaderHint();
        if (this.loadingVideo) this.loadingVideo.classList.add("hidden");
        if (this.actContainer) this.actContainer.classList.remove("hidden");
        // Use timeout to ensure DOM is ready for playing?
        setTimeout(() => {
          if (this.video2) {
            this.video2
              .play()
              .catch((e) => console.log("Auto-play prevented", e));
          }
        }, 100);
      }

      skipToMainVideo() {
        this.hideLoaderHint();
        if (this.loadingVideo) this.loadingVideo.classList.add("hidden");
        if (this.mainVideo) this.mainVideo.classList.remove("hidden");
        if (this.actContainer) this.actContainer.classList.remove("hidden"); // Ensure content is visible

        if (this.video2) {
          this.video2
            .play()
            .catch((error) => console.log("Error playing video2:", error));
        }
      }

      setupVideoTransition() {
        if (!this.video1) return;

        this.setupLoaderHint();

        this.video1.addEventListener("ended", () => {
          this.hideLoaderHint();
          if (this.loadingVideo) this.loadingVideo.classList.add("hidden");
          if (this.mainVideo) this.mainVideo.classList.remove("hidden");
          if (this.actContainer) this.actContainer.classList.remove("hidden");

          if (this.video2) {
            this.video2
              .play()
              .catch((error) => console.log("Error playing video2:", error));
          }
        });

        this.video1.addEventListener("play", () => {
          if (this.video2) this.video2.load();
        });

        this.video1.play().catch((error) => {
          console.log("Error playing intro video:", error);
          // If intro fails to play (e.g. browser policy), skip it
          this.skipToMainVideo();
        });
      }

      setupLoaderHint() {
        if (!this.video1 || !this.scrollHint) return;
        const threshold = Number(this.scrollHint.dataset.threshold || 0.75);
        const revealThreshold = Number.isFinite(threshold) ? threshold : 0.75;

        this.video1.addEventListener("timeupdate", () => {
          if (!this.video1.duration || this.video1.duration <= 0) return;
          const progress = this.video1.currentTime / this.video1.duration;
          if (progress >= revealThreshold) {
            this.scrollHint.classList.add("visible");
          } else {
            this.scrollHint.classList.remove("visible");
          }
        });
      }

      hideLoaderHint() {
        if (this.scrollHint) this.scrollHint.classList.remove("visible");
      }
    }

    class SliderManager {
      constructor() {
        this.sliderContainers = document.querySelectorAll(".slider-container");
        this.init();
      }

      init() {
        this.sliderContainers.forEach((container) => {
          new SliderInstance(container);
        });
      }
    }

    class SliderInstance {
      constructor(container) {
        this.container = container;
        this.sliderId = container.getAttribute("data-slider-id");
        this.slider = container.querySelector(".slider");
        this.slides = Array.from(container.querySelectorAll(".slide"));
        this.indicatorsContainer = document.querySelector(
          `.indicators[data-slider-id="${this.sliderId}"]`
        );
        this.indicators = this.indicatorsContainer
          ? Array.from(this.indicatorsContainer.querySelectorAll(".dot"))
          : [];
        this.currentSlideIndex = 0;
        this.isAnimating = false;

        // Configuración del IntersectionObserver
        this.observer = new IntersectionObserver(
          (entries) => this.handleIntersection(entries),
          {
            root: this.slider,
            threshold: [0.93, 0.99], // Activar cuando esté al menos 95% visible
          }
        );

        this.init();
      }

      init() {
        // Inicializar primer slide
        if (this.slides.length > 0) this.slides[0].classList.add("focused");
        if (this.indicators.length > 0)
          this.indicators[0].classList.add("active");
        this.setupEventListeners();

        // Observar todos los slides
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      setupEventListeners() {
        // Usar delegación de eventos para los slides
        if (this.slider) {
          this.slider.addEventListener("click", (event) => {
            const slide = event.target.closest(".slide");
            if (!slide) return;

            const index = this.slides.indexOf(slide);
            if (index !== -1 && !slide.classList.contains("focused")) {
              this.scrollToSlide(index);
            }
          });
        }

        // Usar delegación de eventos para los indicadores
        if (this.indicatorsContainer) {
          this.indicatorsContainer.addEventListener("click", (event) => {
            const dot = event.target.closest(".dot");
            if (dot) {
              const index = this.indicators.indexOf(dot);
              if (index !== -1) this.scrollToSlide(index);
            }
          });
        }
      }

      handleIntersection(entries) {
        entries.forEach((entry) => {
          const slide = entry.target;
          const index = this.slides.indexOf(slide);

          if (entry.isIntersecting && entry.intersectionRatio > 0.95) {
            // Solo si está casi completamente visible (>95%)
            slide.classList.add("focused");
            if (this.indicators[index])
              this.indicators[index].classList.add("active");

            if (!this.isAnimating) {
              this.currentSlideIndex = index;
            }
          } else {
            slide.classList.remove("focused");
            if (this.indicators[index])
              this.indicators[index].classList.remove("active");
          }
        });
      }

      scrollToSlide(index) {
        if (this.isAnimating) return;
        this.isAnimating = true;

        const slide = this.slides[index];
        const sliderRect = this.slider.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const offset =
          slide.offsetLeft - sliderRect.width / 2 + slideRect.width / 2;

        this.slider.scrollTo({
          left: offset,
          behavior: "smooth",
        });

        setTimeout(() => {
          this.isAnimating = false;
        }, 500);
      }

      scrollToSection(sectionId) {
        const section = document.getElementById(sectionId);
        if (section) section.scrollIntoView({ behavior: "smooth" });
      }
    }

    class AnimationManager {
      constructor() {
        this.revealElements = document.querySelectorAll(".reveal");
        this.imageWrapper = document.querySelector(".image-wrapper");
        this.exteriorImage = document.querySelector(".image-exterior");
        this.interiorImage = document.querySelector(".image-interior");

        this.observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.1,
        };

        this.observerCallback = this.observerCallback.bind(this);
        this.updateParallax = this.updateParallax.bind(this);

        this.init();
      }

      init() {
        this.observer = new IntersectionObserver(
          this.observerCallback,
          this.observerOptions
        );

        this.revealElements.forEach((el) => this.observer.observe(el));
        if (this.imageWrapper) this.observer.observe(this.imageWrapper);
      }

      observerCallback(entries, observer) {
        entries.forEach((entry) => {
          const target = entry.target;

          if (entry.isIntersecting) {
            if (target.classList.contains("reveal")) {
              target.classList.add("active");
            }

            if (target === this.imageWrapper) {
              window.addEventListener("scroll", this.updateParallax);
              this.updateParallax();
            }
          } else {
            if (target.classList.contains("reveal")) {
              target.classList.remove("active");
            }

            if (target === this.imageWrapper) {
              window.removeEventListener("scroll", this.updateParallax);
              this.resetParallax();
            }
          }
        });
      }

      updateParallax() {
        if (!this.imageWrapper) return;

        const rect = this.imageWrapper.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight && rect.bottom > 0) {
          const speed = 0.1;
          const offset = (windowHeight - rect.top) * speed;

          if (this.exteriorImage) {
            this.exteriorImage.style.transform = `translate(${-offset}px, ${offset}px)`;
          }
          if (this.interiorImage) {
            this.interiorImage.style.transform = `translate(${offset}px, ${-offset}px)`;
          }
        }
      }

      resetParallax() {
        if (this.exteriorImage) this.exteriorImage.style.transform = "";
        if (this.interiorImage) this.interiorImage.style.transform = "";
      }
    }

    class InterlinkManager {
      constructor() {
        this.container = document.querySelector(".interlink-content");
        this.mountSections = Array.from(
          document.querySelectorAll(".mount-section")
        );
        this.mounts = Array.from(document.querySelectorAll(".mount"));
        this.currentMount = -1;
        this.currentSection = -1;
        this.mainElement =
          document.getElementById("MainContent") ||
          document.querySelector("main") ||
          document.body;

        this.init();
      }

      init() {
        if (!this.container) return;
        window.addEventListener("scroll", () => this.handleScroll());
      }

      handleScroll() {
        if (!this.container) return;

        const windowHeight = window.innerHeight;
        const containerRect = this.container.getBoundingClientRect();

        // Verificar si el bg está visible
        if (
          containerRect.top < windowHeight / 3 &&
          containerRect.bottom > windowHeight / 6
        ) {
          if (this.mainElement) this.mainElement.classList.add("interlink");
        } else {
          if (this.mainElement) this.mainElement.classList.remove("interlink");
        }

        this.mountSections.forEach((section, index) => {
          const sectionRect = section.getBoundingClientRect();
          const sectionTop = sectionRect.top;

          // Verificar si la sección está en el rango de activación
          const isInActiveRange =
            sectionTop < windowHeight * 0.6 &&
            sectionTop > -sectionRect.height * 0.4;

          if (isInActiveRange) {
            if (this.currentSection !== index) {
              // Desactivar la sección anterior
              if (this.currentSection >= 0) {
                this.mountSections[this.currentSection].classList.remove(
                  "active"
                );
              }
              // Activar la nueva sección
              section.classList.add("active");
              this.currentSection = index;
            }
          } else {
            // Desactivar la sección si está fuera del rango
            section.classList.remove("active");
            if (this.currentSection === index) {
              this.currentSection = -1;
            }
          }

          // Activar la montura cuando la sección esté más cerca del centro
          const isInMountRange =
            sectionTop < windowHeight * 0.5 &&
            sectionTop > -sectionRect.height * 0.5;
          if (isInMountRange) {
            this.updateMounts(index);
          }
        });
      }

      updateMounts(index) {
        if (index === this.currentMount) return;

        // Ocultar todos los montajes
        this.mounts.forEach((mount) => {
          mount.classList.remove("active");
        });

        // Mostrar el montaje correspondiente
        if (index >= 0 && index < this.mounts.length) {
          this.mounts[index].classList.add("active");
        }

        this.currentMount = index;
      }
    }

    class FAQManager {
      constructor() {
        this.faqItems = document.querySelectorAll(".faq-item");
        this.initializeFAQ();
      }

      initializeFAQ() {
        this.faqItems.forEach((item) => {
          const question = item.querySelector(".faq-question");
          const answer = item.querySelector(".faq-answer");

          // Ensure it starts closed
          if (answer) answer.classList.remove("active");
          if (question && question.querySelector(".faq-icon")) {
            question.querySelector(".faq-icon").style.transform =
              "rotate(45deg)";
          }

          // Configurar atributos ARIA
          this.setupAccessibility(question, answer);

          // Añadir event listeners
          // Use a flag to prevent duplicate listeners
          if (!question.dataset.listenerAttached) {
            question.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              this.toggleAnswer(answer, question);
            });

            question.addEventListener("keypress", (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.toggleAnswer(answer, question);
              }
            });
            question.dataset.listenerAttached = "true";
          }
        });
      }

      toggleAnswer(answer, question) {
        if (!answer || !question) return;
        const isExpanded = answer.classList.contains("active");

        // Actualizar el estado ARIA
        question.setAttribute("aria-expanded", !isExpanded);

        // Toggle solo de la respuesta
        answer.classList.toggle("active");

        const icon = question.querySelector(".faq-icon");
        if (icon) {
          icon.style.transform = isExpanded ? "rotate(45deg)" : "rotate(0deg)";
        }
      }

      setupAccessibility(question, answer) {
        if (!question || !answer) return;
        const answerId = `faq-answer-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        question.setAttribute("role", "button");
        question.setAttribute("aria-expanded", "false");
        question.setAttribute("tabindex", "0");
        answer.setAttribute("id", answerId);
        question.setAttribute("aria-controls", answerId);
      }
    }

    function initIdleSrcQueue() {
      const CLASS = "js-idle-src";
      if (window.landingIdleSrcBound) return;
      if (!document.querySelector("." + CLASS)) return;
      window.landingIdleSrcBound = true;

      const constrained = () => {
        const c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!c) return false;
        if (c.saveData) return true;
        const type = String(c.effectiveType || "");
        return type === "slow-2g" || type === "2g";
      };

      const mediaReady = (el) => {
        if (el.tagName === "IMG") return el.complete && el.naturalWidth > 1;
        return (el.readyState || 0) >= 2;
      };

      const isPlaceholder = (src) => !src || /blank\.gif(\?|$)/i.test(src);

      const markLoaded = (el) => {
        if (el.tagName === "IMG") el.classList.add("loaded");
      };

      const assignOne = (el) => {
        const data = el.getAttribute("data-src") || "";
        const src = el.getAttribute("src") || "";
        if (!data || !isPlaceholder(src)) return mediaReady(el);
        if (el.tagName === "VIDEO") el.preload = "auto";
        el.src = data;
        if (el.tagName === "VIDEO") {
          try {
            el.load();
          } catch (err) {}
        }
        return false;
      };

      const assignSrc = (el) => {
        const ready = assignOne(el);
        if (el.classList.contains("tr20-layers__video")) {
          document.querySelectorAll(".tr20-layers__video.js-idle-src").forEach(assignOne);
        }
        if (ready || mediaReady(el)) {
          markLoaded(el);
          return true;
        }
        return false;
      };

      const ordered = () =>
        Array.from(document.querySelectorAll("." + CLASS)).sort((a, b) => {
          const ao = Number(a.getAttribute("data-idle-order") || "0");
          const bo = Number(b.getAttribute("data-idle-order") || "0");
          if (ao !== bo) return ao - bo;
          const pos = a.compareDocumentPosition(b);
          if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
          if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
          return 0;
        });

      const nextItem = () =>
        ordered().find((el) => {
          const data = el.getAttribute("data-src") || "";
          const src = el.getAttribute("src") || "";
          return !!(data && isPlaceholder(src));
        });

      const waitReady = (el, done) => {
        if (el.tagName === "IMG") {
          if (mediaReady(el)) {
            markLoaded(el);
            done();
            return;
          }
        } else if ((el.readyState || 0) >= 1) {
          done();
          return;
        }
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          markLoaded(el);
          el.removeEventListener("loadedmetadata", finish);
          el.removeEventListener("loadeddata", finish);
          el.removeEventListener("canplaythrough", finish);
          el.removeEventListener("load", finish);
          el.removeEventListener("error", finish);
          clearTimeout(timer);
          done();
        };
        const timer = setTimeout(finish, el.tagName === "VIDEO" ? 380 : 6000);
        el.addEventListener("loadedmetadata", finish, { once: true });
        el.addEventListener("loadeddata", finish, { once: true });
        el.addEventListener("load", finish, { once: true });
        el.addEventListener("error", finish, { once: true });
      };

      const idle = (fn) => {
        if (typeof window.requestIdleCallback === "function") {
          window.requestIdleCallback(fn, { timeout: 1800 });
          return;
        }
        setTimeout(fn, 280);
      };

      let started = false;
      const pump = () => {
        if (document.visibilityState === "hidden") {
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") idle(pump);
          }, { once: true });
          return;
        }
        const el = nextItem();
        if (!el) return;
        assignSrc(el);
        waitReady(el, () => idle(pump));
      };

      const start = () => {
        if (started) return;
        started = true;
        if (constrained()) return;
        idle(pump);
      };

      document.addEventListener("landing:idle-media", start);
      window.addEventListener("load", () => setTimeout(start, 10000), { once: true });
    }

    // Initialize all functionality
    try {
      new VideoManager();
      new SliderManager();
      new AnimationManager();
      new InterlinkManager();
      new FAQManager();
      initIdleSrcQueue();
    } catch (error) {
      console.error("Error initializing managers:", error);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLanding);
  } else {
    initLanding();
  }

  // Support for Shopify Theme Editor events
  document.addEventListener("shopify:section:load", initLanding);
}
